import { StandardGrid, StandardGridPresentationType } from '@apply/components';
import { Column } from 'devextreme-react/data-grid';
import { IBridgeLoanGridRecord } from '@apply/api/src/api/loanApi';
import { fullTextRender } from '../../../../common/functions/renderers/fullTextRender';
import { repaidLoanFormats as formats } from '../functions/formatters/repaidLoanFormats';

export interface RepaidPortfolioPropertiesGridProps {
    loan: IBridgeLoanGridRecord;
}

// A portfolio's properties, under its row in the Repaid grid
export const RepaidPortfolioPropertiesGrid = ({ loan }: RepaidPortfolioPropertiesGridProps) => (
    <div
        className='subGrid'
        style={{ padding: '10px 20px' }}
    >
        <StandardGrid
            dataSource={loan.properties}
            keyExpr='id'
            presentationType={StandardGridPresentationType.Enhanced}
            noDataText='No Properties Found'
            pagerVisible={false}
            rowAlternationEnabled={true}
            showColumnHeaders={true}
            showBorders={true}
            remoteOperations={false}
            allowColumnReordering={false}
            width={850}
        >
            <Column
                dataField='bfiNumber'
                caption='Loan'
                width={100}
                alignment='left'
            />
            <Column
                dataField='street'
                caption='Street'
                width={200}
                alignment='left'
            />
            <Column
                dataField='city'
                caption='City'
                width={120}
                alignment='left'
            />
            <Column
                dataField='state'
                caption='State'
                width={50}
                alignment='left'
            />
            <Column
                caption='BFI Refi'
                width={70}
                alignment='left'
                cellRender={() => fullTextRender(loan.refinanceLender)} // The loan's, as in the Apps sub grid
            />
            <Column
                dataField='units'
                caption='Units'
                width={50}
                alignment='left'
            />
            <Column
                dataField='size'
                caption='Est. Size'
                width={100}
                alignment='left'
                customizeText={(e) => formats.currency(e.value)}
            />
            <Column
                dataField='ltv'
                caption='LTV'
                width={60}
                alignment='left'
                customizeText={(e) => formats.ltv(e.value)}
            />
            <Column
                dataField='appraisedValue'
                caption='Appraised'
                width={100}
                alignment='left'
                customizeText={(e) => formats.currency(e.value)}
            />
        </StandardGrid>
    </div>
);
